const backendLink = '/bdsite/';

export default backendLink;